var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-circle-single--circle-geometric-human-person-single-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00021 10.144C10.5782 10.144 11.8574 8.86479 11.8574 7.28683C11.8574 5.70887 10.5782 4.42969 9.00021 4.42969C7.42225 4.42969 6.14307 5.70887 6.14307 7.28683C6.14307 8.86479 7.42225 10.144 9.00021 10.144Z",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.12012 14.6007C4.63011 13.7635 5.34687 13.0717 6.2015 12.5916C7.05612 12.1115 8.01988 11.8594 9.00012 11.8594C9.98035 11.8594 10.9441 12.1115 11.7987 12.5916C12.6534 13.0717 13.3701 13.7635 13.8801 14.6007",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.99986 16.4275C13.1025 16.4275 16.4284 13.1016 16.4284 8.99888C16.4284 4.8962 13.1025 1.57031 8.99986 1.57031C4.89717 1.57031 1.57129 4.8962 1.57129 8.99888C1.57129 13.1016 4.89717 16.4275 8.99986 16.4275Z",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.83413982dae1228580e1cafadf5e736a.svg";
export { ForwardRef as ReactComponent };